import { createSlice } from "@reduxjs/toolkit";

const initialStoreItemState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    storeItemForEdit: undefined,
    lastError: null,
    message: null,
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const storeItemSlice = createSlice({
    name: "storeItems",
    initialState: initialStoreItemState,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error.clientMessage;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            state.message = null;

            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            state.message = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        // getStoreItemById
        storeItemFetched: (state, action) => {
            state.actionsLoading = false;
            state.storeItemForEdit = action.payload.storeItemForEdit;
            state.floorPlans = action.payload.storeItemForEdit.floorPlans;
            state.error = null;

        },
        // getStoreItemChart
        storeItemChartFetched: (state, action) => {

            state.actionsLoading = false;
            state.storeItemChart = action.payload.storeItemChart;
            state.error = null;

        },
        // getStoreItemChart
        storeItemHourlyChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.storeItemChartHour = action.payload.storeItemChartHour;
            state.error = null;

        },
        // getStoreItemChart
        storeItemHourlyZoneChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.storeItemChartHourZone = action.payload.storeItemChartHourZone;
            state.error = null;

        },
        // get list data
        storeItemsFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
            state.storeItemForEdit = undefined;
            state.floorPlans = undefined;
            state.storeItemChart = undefined;
            state.storeItemChartHour = undefined;
            state.storeItemChartHourZone = undefined;
        },
        // createStoreItem
        storeItemCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        // updateStoreItem
        storeItemUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.message = action.payload.msgResponse;
        },
        // storeItemDeleted
        storeItemDeleted: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
            state.actionsLoading = false;
        },
        setMessage: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        floorPlanDeleted: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.filter(item => item.id !== action.payload.id);
        },
        floorPlanUpdated: (state, action) => {
            const { id, floorPlan } = action.payload;
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.map((data) => {

                if (data.id === id) {
                    return floorPlan;
                }

                return data;
            });
        }

    }
});
